import React, { useEffect, useState } from "react";
import styles from "./OtherCourses.module.css";
import { Carousel } from "primereact/carousel";
import { SelectButton } from "primereact/selectbutton";

const OtherCourses = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [value, setValue] = useState(1);

  const items = [
    { name: "Certificaciones", value: 1 },
    { name: "Webinarios", value: 2 },
  ];

  const currentItems = value === 1 ? props.certifications : props.webinars;
  const filledItems = [...currentItems];

  while (filledItems.length < 4) {
    filledItems.push(null); // Añadir espacios vacíos como `null`
  }

  useEffect(() => {
    if (window.innerWidth <= 480 && !isMobile) {
      setIsMobile(true);
    }
  }, [isMobile]);

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const certificationsTemplate = (certification) => {
    if (!certification) {
      return <div className={styles.hiddenSlot}></div>;
    }
    return (
      <div className={styles.certificationBox}>
        <img
          onClick={() =>
            (window.location.href = "/courseInfo/" + certification.id)
          }
          src={certification.imageUrl}
          alt="Certification image"
          className={styles.certificationImage}
        />
        <h1
          onClick={() =>
            (window.location.href = "/courseInfo/" + certification.id)
          }
          className={styles.certificationTitle}
        >
          {certification.topic}
        </h1>
        <h2 className={styles.certificationPrice}>
          {certification.price + " US$"}
        </h2>
      </div>
    );
  };

  return (
    <div>
      <div className={styles.otherCourses}>
        <div className="flex justify-content-end align-items-end">
          <SelectButton
            value={value}
            onChange={(e) => setValue(e.value)}
            optionLabel="name"
            options={items}
            className="mx-6 mt-4"
            allowEmpty={false}
          />
        </div>
        <div className={styles.text}>
          <h1 className={styles.title}>Explora otras capacitaciones</h1>
          <h2 className={styles.subTitle}>
            Enfréntate al futuro con la confianza, las habilidades y las
            herramientas para prosperar
          </h2>
          <Carousel
            value={filledItems}
            itemTemplate={certificationsTemplate}
            numVisible={isMobile ? 1 : 4}
            numScroll={isMobile ? 1 : 4}
            // circular={true}
            className={styles.carousel}
            responsiveOptions={responsiveOptions}
            // autoplayInterval={10000}
          />
        </div>
      </div>
    </div>
  );
};

export default OtherCourses;
